import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';

const TeamPage = () => {
  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        {/* Header */}
        <div className="mb-4">
          <Row className="align-items-center">
            <Col>
              <h2 className="mb-2">
                <FontAwesomeIcon icon="users" className="me-2 text-primary" />
                Gestión de Equipo
              </h2>
              <h5 className="text-700 fw-semi-bold">
                Administra equipos de trabajo y colaboradores
              </h5>
            </Col>
          </Row>
        </div>

        <Card className="shadow-sm">
          <FalconCardHeader title="Equipo" />
          <Card.Body>
            <div className="text-center py-5">
              <FontAwesomeIcon icon="users" size="3x" className="text-muted mb-3" />
              <h4>Módulo de Equipo</h4>
              <p className="text-muted">
                Este módulo está en desarrollo. Aquí podrás gestionar equipos de trabajo.
              </p>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default TeamPage; 